export default {
  name: 'editMemberHeader',
}